<template>
  <div
    class="audio-player"
    :class="{
      edit: isEdit,
    }"
  >
    <audio :src="src" ref="audio-player" type="audio/ogg; codecs=vorbis"></audio>
    <div class="audio-player__controls">
      <svg
        v-baidu-event-tracking="{ feature: 'MEMO卡片', action: '音频播放' }"
        @click="playPause"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.0003 1.6665C5.40782 1.6665 1.66699 5.40733 1.66699 9.99984C1.66699 14.5923 5.40782 18.3332 10.0003 18.3332C14.5928 18.3332 18.3337 14.5923 18.3337 9.99984C18.3337 5.40733 14.5928 1.6665 10.0003 1.6665ZM10.0003 3.33317C13.6921 3.33317 16.667 6.30807 16.667 9.99984C16.667 13.6916 13.6921 16.6665 10.0003 16.6665C6.30856 16.6665 3.33366 13.6916 3.33366 9.99984C3.33366 6.30807 6.30856 3.33317 10.0003 3.33317ZM8.33366 7.11247V12.8872L13.3337 9.99984L8.33366 7.11247Z"
          fill="#55BB8E"
        />
      </svg>

      <div class="audio-player_progress">
        <span class="audio-player_progress__time__current">{{ currentTime }}</span>

        <div class="audio-player_progress__bar">
          <div class="audio-player_progress__bar__progress" :style="{ width: progress + '%' }"></div>
          <div class="audio-player_progress__bar__ball" :style="{ left: progress * 0.94 + '%' }"></div>
        </div>

        <span class="audio-player_progress__time__total">{{ duration }}</span>
      </div>

      <svg
        class="del"
        @click="del"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        v-if="isEdit"
      >
        <path
          d="M8.33301 1.6665L7.49967 2.49984H3.33301V4.1665H4.16634V16.6665C4.16634 17.1017 4.32578 17.5453 4.63997 17.8595C4.95417 18.1737 5.39782 18.3332 5.83301 18.3332H14.1663C14.6015 18.3332 15.0452 18.1737 15.3594 17.8595C15.6736 17.5453 15.833 17.1017 15.833 16.6665V4.1665H16.6663V2.49984H12.4997L11.6663 1.6665H8.33301ZM5.83301 4.1665H14.1663V16.6665H5.83301V4.1665ZM7.49967 5.83317V14.9998H9.16634V5.83317H7.49967ZM10.833 5.83317V14.9998H12.4997V5.83317H10.833Z"
          fill="currentColor"
        />
      </svg>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AudioPlayer',
  props: {
    src: {
      type: String,
      required: true,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    delFun: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      currentTime: '00:00',
      progress: 0,
      duration: '00:00',
    }
  },
  computed: {},
  mounted() {
    const audio = this.$refs['audio-player']

    // get duration
    audio.addEventListener('loadedmetadata', () => {
      const duration = audio.duration
      const minutes = Math.floor(duration / 60)
      const seconds = Math.floor(duration % 60)
      this.duration = `${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`
    })
    audio.addEventListener('timeupdate', () => {
      const currentTime = audio.currentTime
      const minutes = Math.floor(currentTime / 60)
      const seconds = Math.floor(currentTime % 60)
      this.currentTime = `${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`
      this.progress = (currentTime / audio.duration) * 100
    })
  },
  methods: {
    playPause() {
      const audio = this.$refs['audio-player']
      if (audio.paused) {
        audio.play()
      } else {
        audio.pause()
      }
    },
    del() {
      this.$confirm(this.$t('components.AudioPlayer.del.title'), this.$t('components.AudioPlayer.del.tips'), {
        confirmButtonText: this.$t('components.AudioPlayer.del.confirmButtonText'),
        cancelButtonText: this.$t('components.AudioPlayer.del.cancelButtonText'),
        type: 'warning',
      })
        .then(() => {
          this.delFun()
        })
        .catch(() => {})
    },
  },
}
</script>
<style lang="scss" scoped>
.audio-player {
  max-width: 320px;
  background: #f7f7ed;
  border-radius: 6px;
  margin: 10px 0;
  &__controls {
    padding: 10px;
    svg {
      cursor: pointer;
      width: 20px;
      height: 20px;
      &:first-child {
        margin-right: 10px;
      }

      &:last-child {
        margin-left: 10px;
      }
    }
    .del path {
      fill: #b9b9b9;
    }
  }
  &__controls,
  &_progress {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  &_progress {
    span {
      font-weight: 700;
      font-size: 14px;
      line-height: 25px;
      text-align: justify;
      color: #454545;
      &:first-child {
        margin-right: 10px;
      }

      &:last-child {
        margin-left: 10px;
      }
    }
    &__bar {
      background: #d3ecdd;
      border-radius: 4px;
      height: 2px;
      width: 150px;
      position: relative;

      &__progress {
        background: #55bb8e;
        height: 2px;
        border-radius: 4px;
        max-width: 150px;
      }
      &__ball {
        width: 10px;
        height: 10px;
        background: #55bb8e;
        border-radius: 50%;
        position: absolute;
        top: -4px;
      }
    }
  }
}

.edit {
  margin: 0 18px 20px 18px;
}
</style>
<style scoped lang="scss">
body.dark_mode .audio-player {
  background: #171716;
  &__controls {
    .del {
      fill: #5f5f5f;
    }
  }
  &__controls,
  &_progress {
    span {
      color: #9d9d9d;
    }
  }
  &_progress {
    &__bar {
      background: #2f2f2f;
      &__progress {
        background: #55bb8e;
      }
      &__ball {
        background: #55bb8e;
      }
    }
  }
}
</style>
